import { OrchardBrands } from '../songwhipApi/types';
import AwalIcon from '~/app/components/Icon/AwalIcon';
import OrchardIcon from '~/app/components/Icon/OrchardIcon';
import SmeIcon from '~/app/components/Icon/SmeIcon';

export const toBrandName = (orchardBrand: OrchardBrands | undefined) =>
  orchardBrand
    ? {
        [OrchardBrands.SME]: 'Sony Music Entertainment',
        [OrchardBrands.AWAL]: 'AWAL',
        [OrchardBrands.ORCHARD]: 'The Orchard',
      }[orchardBrand]
    : '';

export const toBrandIcon = (orchardBrand: OrchardBrands | undefined) =>
  orchardBrand &&
  {
    [OrchardBrands.SME]: SmeIcon,
    [OrchardBrands.AWAL]: AwalIcon,
    [OrchardBrands.ORCHARD]: OrchardIcon,
  }[orchardBrand];
